import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const addressDataClassName = DataClassName.ADDRESS
const addressEndpoint = PisaDataClassEndpoint.ADDRESS

export function pisaAddressDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(addressDataClassName, {
    title: addressDataClassName,
    restApi: createPisaRestApiConfig(addressEndpoint),
    attributes,
  })
}
